module.exports = __webpack_public_path__ + "components/flag/static/square/gr-e3dbdf4de188c92de54c84375195676a.svg";